import { render, staticRenderFns } from "./ArchivedCourses.vue?vue&type=template&id=3f57160f&"
import script from "./ArchivedCourses.vue?vue&type=script&lang=js&"
export * from "./ArchivedCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports